import { EntityFacadeService } from "../../../shared/store/entity-store/entity-facade.service";
import { WidgetData, WidgetType } from "../models/dashboard.model";
import { EntityStoreState } from "../../../shared/store/store-types.model";
import { WidgetDataApiService } from "../services/widget-data-api.service";
import { Injectable, signal } from "@angular/core";
import { firstValueFrom } from "rxjs";
import {
  Untrack,
  UpdateStatus,
} from "../../../shared/store/utils/store-utils.service";

@Injectable({
  providedIn: "root",
})
export class WidgetDataFacadeService extends EntityFacadeService<
  WidgetData,
  WidgetDataApiService,
  EntityStoreState
> {
  /** Tick incrémenté à chaque "actualiser" — déclenche le re-fetch dans les widgets. */
  refreshTick = signal(0);

  constructor(private widgetApiService: WidgetDataApiService) {
    super(widgetApiService);
    window["widget"] = this;
  }

  /**
   * Vide le cache widget côté back puis purge le store local et incrémente
   * `refreshTick` — les widgets qui s'y abonnent rappellent `loadOne(type)`.
   */
  @Untrack
  @UpdateStatus
  async refreshAll() {
    await firstValueFrom(this.widgetApiService.refreshAll());
    // Vide le store front : les widgets verront `getById()` revenir undefined
    // puis se re-loaderont via leur effect/computed habituel.
    for (const id of this.getAllEntities()()?.map((w) => w.id) ?? []) {
      this.store.removeOne(id as WidgetType);
    }
    this.refreshTick.update((v) => v + 1);
  }
}
